import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "../Layout";
import ProtectedRoute from "../ProtectedRoute"; // Import the protected route
import GiftShop from "../pages/GiftShop";
import PtwoP from "../pages/ptwopproduct/Ptwop";
import Marketplace from "../pages/PtwoPMarket/markeplace";
import Editproduct from "../pages/PtwoPMarket/editproduct";
import Promoteproduct from "../pages/PtwoPMarket/promote";
import ProductDetails from "../pages/PtwoPMarket/productdetails";
import Postaproduct from "../pages/ptwopproduct/postaproduct";
import DigitalCourses from "../pages/DigitalCourses";
import GiftItemDetails from "../pages/GiftItemDetails";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Product from "../pages/Product";
import CourseDetails from "../pages/CourseDetails";
import Cart from "../pages/Cart";
import Tracking from "../pages/Tracking";
import GiftsFavourite from "../pages/GiftsFavourite";
import GiftCheckoutForm from "../pages/GiftCheckoutForm";
import CourseCheckoutForm from "../pages/CourseCheckoutForm";
import TrackOrder from "../pages/TrackOrder";
import CoursesOrderHistory from "../pages/CoursesOrderHistory";
import CoursesFavourite from "../pages/CoursesFavourite";
import ProductFavourite from "../pages/ptwopproduct/productfavourite";

import GiftsOrderHistory from "../pages/GiftsOrderHistory";
import RateContent from "../components/CheckoutSidebar/RateContent";
import DeleteModal from "../pages/PtwoPMarket/deleteproduct";

// Define your routes
const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />, // Public login page
  },
  {
    path: "/",
    element: <Layout />, // Layout with header/footer
    children: [
      {
        element: <ProtectedRoute />, // 🔒 Wrap all protected routes
        children: [
          { path: "home", element: <Home /> },
          {
            path: "product",
            element: <Product />,
            children: [
              { path: "tracking", element: <Tracking /> },
              { path: "track-order", element: <TrackOrder /> },
              { path: "cart", element: <Cart /> },
              { path: "ptwop", element: <PtwoP /> },
              { path: "favourite", element: <ProductFavourite /> },
              { path: "marketplace", element: <Marketplace /> },
              { path: "/product/edit/:productId", element: <Editproduct /> },
              { path: "details/:productId", element: <ProductDetails /> },
              { path: "/product/promote/:productId", element: <Promoteproduct /> },
              { path: "/product/delete/:productId", element: <DeleteModal /> },
              { path: "post_a_product", element: <Postaproduct /> },
              {
                path: "giftshop",
                element: <GiftShop />,
                children: [
                  { path: "favourite", element: <GiftsFavourite /> },
                  { path: "order-history", element: <GiftsOrderHistory /> },
                  { path: "rating", element: <RateContent /> },
                ],
              },
              { path: "gift-details/:id", element: <GiftItemDetails /> },
              {
                path: "digital-courses",
                element: <DigitalCourses />,
                children: [
                  { path: "favourite", element: <CoursesFavourite /> },
                  { path: "order-history", element: <CoursesOrderHistory /> },
                  { path: "rating", element: <RateContent /> },
                ],
              },
              { path: "course-details/:id", element: <CourseDetails /> },
              { path: "course-details/checkout-form", element: <CourseCheckoutForm /> },
              { path: "gift-details/checkout-form", element: <GiftCheckoutForm /> },
            ],
          },
        ],
      },
    ],
  },
]);

// Provide the router
const AppRouter = () => {
  return <RouterProvider router={router} />;
};

export default AppRouter;
